import { lazy } from 'react';

import { PageSuspense } from 'src/components';


const SystemSettingUpdatePage = lazy(() => import('../views/update/SystemSettingUpdatePage'));

export function SystemSettingUpdatePageLazy() {
	return (
		<PageSuspense>
			<SystemSettingUpdatePage />
		</PageSuspense>
	);
}
